import React from "react";
import { Box, Typography } from "@mui/material";
import {
  LineChart,
  Line,
  Tooltip,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

const LineGraph = ({ sessionNotes, type }) => {
  //console.log("Session Notes:", sessionNotes); // Debug log

  // Custom tooltip renderer
  const customTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { payload: data } = payload[0]; // Extract data from the payload

    if (type === "sessionNotes") { 
      return (
        <Box
          sx={{
            padding: "10px",
            backgroundColor: "#333",
            color: "white",
            borderRadius: "5px",
            boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.5)",
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", marginBottom: "5px" }}>
            Date: {data.date}
          </Typography>
          <Typography variant="body2"> Total Session Notes: {data.value}</Typography>
          <Typography variant="body2" sx={{ marginTop: "5px" }}>
            Procedure Code :-
          </Typography>
          {Object.entries(data.breakdown || {}).map(([key, value]) => (
            <Typography key={key} variant="body2">
              {key}: {value}
            </Typography>
          ))}
        </Box>
      );
    } else if (type === "credits") {
        return (
            <Box
              sx={{
                padding: "10px",
                backgroundColor: "#333",
                color: "white",
                borderRadius: "5px",
                boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.5)",
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: "bold", marginBottom: "5px" }}>
                Date: {data.date}
              </Typography>
              <Typography variant="body2">Credit Used: {data.value}</Typography>
              <Typography variant="body2" sx={{ marginTop: "5px" }}>
              </Typography>
             
              
            </Box>
          );
        }}
    return null;
  };

  return (
    <Box
     sx={{
        marginTop:"80px",
        marginRight:"10px"
     }}
    >
    <ResponsiveContainer width="100%" height={400} >
      <LineChart
        data={sessionNotes} // Ensure this matches your [{date, value, breakdown}] format
        margin={{ top: 5, right: 50, left: 20, bottom: 55 }}                
          sx={{
            "& .MuiChartSeries-legend .MuiTypography-root": {
              color: "white",
              backgroundColor: "white",
            },
            "& .MuiTooltip-popper .MuiTooltip-tooltip": {
              color: "white",
            },
          }}
      >
       
        <XAxis dataKey="date" tick={{ fill: "white",angle: -45,textAnchor: "end", }}/>
        <YAxis tick={{ fill: "white" }}
        allowDecimals={false} // Prevent decimals
        domain={[0, 'auto']} // Auto-adjust domain to avoid overlaps
        tickFormatter={(value) => parseInt(value, 10)} // Convert to integer without creating duplicates
      />
        <Tooltip content={customTooltip} />
        <Line
          type="monotone"
          dataKey="value" // The total value for the date
          stroke="#8884d8"
          animationDuration={150}
        />
      </LineChart>
    </ResponsiveContainer>
    </Box>
  );
};

export default LineGraph;
